import api from "./api";
import Utils from "@/common/Utils";

class LogService {
  getLogList(params) {
    return api
      .post("/log/getLogList", params)
      .then((response) => {
        if (response.data.success) {
          Utils.log(response.data)
        }

        return response.data;
      });
  }

  insertLogList(params) {
    return api
      .post("/log/insertLogList", params)
      .then((response) => {
        if (response.data.success) {
          Utils.log(response.data)
        }

        return response.data;
      });
  }
}

export default new LogService();
